(function () {
    document.querySelectorAll('[data-related-products]').forEach(function (root) {
      const productId = root.dataset.productId;
      const sectionId = root.dataset.sectionId;
      const intent = root.dataset.intent || 'related';
      const limit = root.dataset.limit || 4;
      if (!productId || root.dataset.loaded) return;

      const url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') +
        'recommendations/products?section_id=' + encodeURIComponent(sectionId) +
        '&product_id=' + encodeURIComponent(productId) +
        '&intent=' + encodeURIComponent(intent) +
        '&limit=' + encodeURIComponent(limit);

      function fetchAndSwap() {
        if (root.dataset.loaded) return;
        root.dataset.loaded = 'true';
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (text) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, 'text/html');
            const fresh = doc.querySelector('[data-related-products]');
            if (fresh) {
              root.replaceChildren(...Array.from(fresh.childNodes).map(function (n) { return n.cloneNode(true); }));
            } else {
              root.style.display = 'none';
            }
          })
          .catch(function () { root.style.display = 'none'; });
      }

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { fetchAndSwap(); io.disconnect(); }
          });
        }, { rootMargin: '300px' });
        io.observe(root);
      } else {
        fetchAndSwap();
      }
    });
  })();
